import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import "./styles/font.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <div style={{ background: "#eff0f1" }}>
      <App />
    </div>
  </BrowserRouter>
);
